import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { patientAction } from 'src/redux/actions/constant';

import patientService from 'src/services/apiServices/patientServices';

const { FAILURE_VALIDATE_CSV_TEMPLATE, SUCCESS_VALIDATE_CSV_TEMPLATE, REQUEST_VALIDATE_CSV_TEMPLATE } =
  patientAction;

function* validateCSVTemplates(action: any): SagaReturnType<any> {
  try {
    // yield put({ type: LOADER_ON });
    const response = yield call(patientService.validateCSVTemplate, action.payload);
    if (response?.status === 201) {
      yield put({ type: SUCCESS_VALIDATE_CSV_TEMPLATE, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_VALIDATE_CSV_TEMPLATE, payload: error });
  }
}

function* validateCSVTemplateSaga() {
  yield takeEvery(REQUEST_VALIDATE_CSV_TEMPLATE, validateCSVTemplates);
}

export default validateCSVTemplateSaga;
